import { BaseMoney } from './commercetools'
import { Image } from './image'
import { DiscountedPrice, ProductToolTip } from './product'

export interface CreateBookmarkList {
  productIds: string[]
  products?: {
    sku: string
    quantity: number
  }[]
}

export interface CreateProjectBookMark extends CreateCustomerList {
  name: string
  projectId: string
  status: boolean
}

export interface CreateCustomerList extends CreateBookmarkList {
  name?: string
  type?: string
}

export type ListsSortOptions = {
  value: string
  label: string
}

export interface ListProductItem {
  id: string
  catNo?: string
  sku?: string
  thumbnail?: Image
  title?: string
  url?: string
  inStock?: boolean
  rating?: number
  reviewCount?: number
  quantity?: number
  finalPrice?: DiscountedPrice
  regularPrice?: BaseMoney
}

export interface ListDetailsProps {
  id: string
  name: string
  productCount?: number
  sortOptions?: ListsSortOptions[]
  zeroProductsTitle?: string
  zeroProductDescription?: string
  zeroProductsImage?: Image
  products?: ListProductItem[]
  listSummaryTitle?: string
  listSubtotalTitle?: string
  listSubtotal?: BaseMoney
  listSummaryProductCount?: number
  browseAllAction?: {
    href: string
    title: string
  }
}

export interface CustomerList extends ProductToolTip, ListDetailsProps {
  id: string
  name: string
  lineItems?: {
    id: string
    productId: string
    thumbnail: Image
    quantity: number
  }[]
  thumbnails?: Image[]
  numberOfProducts?: number
  createdAt?: string
  /*
   * type - gives info about the type of CustomerList. By default, it is a shoppingList.
   * possible values: bookmark, shopping-list
   * default value: undefined ( points to a shoppingList )
   */
  type?: string
}

export enum CustomerListType {
  Shopping = 'shopping-list',
  Project = 'project-list',
}
